import TopRated from "./TopRated";

export default TopRated;
